import ActivityIconImport from './activity.svg?react';
import AddCircleLineIconImport from './add_circle_line.svg?react';
import AddLineImport from './add_line.svg?react';
import ArchiveLineIconImport from './archive_line.svg?react';
import ArrowDownLineIconImport from './arrow_down_line.svg?react';
import ArrowLeftLineIconImport from './arrow_left_line.svg?react';
import ArrowRightLineIconImport from './arrow_right_line.svg?react';
import BankFillIconImport from './bank_fill.svg?react';
import BankLineIconImport from './bank_line.svg?react';
import BellCircleIconImport from './bell-circle.svg?react';
import BellRingingFillIconImport from './bell_ringing_fill.svg?react';
import BellRingingLineIconImport from './bell_ringing_line.svg?react';
import BillLineIconImport from './bill_line.svg?react';
import BookmarkFillIconImport from './bookmark_fill.svg?react';
import BookmarkLineIconImport from './bookmark_line.svg?react';
import BriefcaseLineIconImport from './briefcase_line.svg?react';
import BubbleLineIconImport from './bubble_line.svg?react';
import CalendarFillIconImport from './calendar_fill.svg?react';
import CalendarLineIconImport from './calendar_line.svg?react';
import CalendarMonthIconImport from './calendar_month_line.svg?react';
import CalendarTimeAddFillIconImport from './calendar_time_add_fill.svg?react';
import CellPhoneLineIconImport from './cellphone_line.svg?react';
import Chat1FillIconImport from './chat_1_fill.svg?react';
import Chat1LineIconImport from './chat_1_line.svg?react';
import Chat3LineIconImport from './chat_3_line.svg?react';
import CheckCircleFillIconImport from './check_circle_fill.svg?react';
import CheckCircleLineIconImport from './check_circle_line.svg?react';
import CheckFillIconImport from './check_fill.svg?react';
import CheckGreenIconImport from './check_green.svg?react';
import CheckLineIconImport from './check_line.svg?react';
import ChurchLineIconImport from './church_line.svg?react';
import Classify2FillIconImport from './classify_2_fill.svg?react';
import Classify2LineIconImport from './classify_2_line.svg?react';
import CloseCircleFillIconImport from './close_circle_fill.svg?react';
import CloseCircleLineIconImport from './close_circle_line.svg?react';
import CloseLineIconImport from './close_line.svg?react';
import Comment2LineIconImport from './comment_2_line.svg?react';
import CommentLineIconImport from './comment_line.svg?react';
import CompassFillIconImport from './compass_fill.svg?react';
import CompassLineIconImport from './compass_line.svg?react';
import ComputerLineIconImport from './computer_line.svg?react';
import CopyLineIconImport from './copy_line.svg?react';
import FileDefaultIconImport from './default_file.svg?react';
import Delete2LineIconImport from './delete_2_line.svg?react';
import DocumentFileIconImport from './doc.svg?react';
import Document3FillIconImport from './document_3_fill.svg?react';
import Document3LineIconImport from './document_3_line.svg?react';
import DocumentLineIconImport from './document_line.svg?react';
import DotGridLineIconImport from './dot_grid_line.svg?react';
import DownLineImport from './down_line.svg?react';
import DownSmallLineIconImport from './down_small_line.svg?react';
import DropboxIconImport from './dropbox.svg?react';
import EarthLineIconImport from './earth_line.svg?react';
import EnterLineIconImport from './enter-line.svg?react';
import EventIconImport from './event.svg?react';
import ExchangeDollarLineIconImport from './exchange_dollar_line.svg?react';
import ExitLineIconImport from './exit_line.svg?react';
import Eye2LineIconImport from './eye_2_line.svg?react';
import EyeCloseIconImport from './eye_close_line.svg?react';
import EyeLineIconImport from './eye_line.svg?react';
import FacebookIconImport from './fb.svg?react';
import FileCheckLineIconImport from './file_check_line.svg?react';
import Flag1LineIconImport from './flag_1_line.svg?react';
import FolderIconImport from './folder.svg?react';
import FolderLineIconImport from './folder_line.svg?react';
import ForbidCircleLineIconImport from './forbid_circle_line.svg?react';
import GameIconImport from './game.svg?react';
import GridLineIconImport from './grid_line.svg?react';
import GroupLineIconImport from './group_line.svg?react';
import HandHeartFillIconImport from './hand_heart_fill.svg?react';
import HandHeartLineIconImport from './hand_heart_line.svg?react';
import HeartFillIconImport from './heart_fill.svg?react';
import HeartLineIconImport from './heart_line.svg?react';
import HeartbeatIconImport from './heartbeat.svg?react';
import HeartBeatLineIconImport from './heartbeat_line.svg?react';
import HistoryLineIconImport from './history_line.svg?react';
import Home4FillIconImport from './home_4_fill.svg?react';
import Home4LineIconImport from './home_4_line.svg?react';
import HornLineIconImport from './horn_line.svg?react';
import HospitalLineIconImport from './hospital_line.svg?react';
import withAntIconWrapper from './icon-wrapper/withAntIconWrapper';
import ImgFileIconImport from './img.svg?react';
import InboxLineCircleIconImport from './inbox_line_circle.svg?react';
import InformationLineIconImport from './information_line.svg?react';
import InviteIconImport from './invite.svg?react';
import Key2LineIconImport from './key_2_line.svg?react';
import LayoutLeftFillIconImport from './layout_left_fill.svg?react';
import LayoutLeftLineIconImport from './layout_left_line.svg?react';
import LightLineIconImport from './light_line.svg?react';
import LinkLineImport from './link_line.svg?react';
import LinkedInIconImport from './linkedin.svg?react';
import ListCheckIconImport from './list-check.svg?react';
import ListCircleIconImport from './list-circle.svg?react';
import ListCheck3LineIconImport from './list_check_3_line.svg?react';
import ListCheckLineIconImport from './list_check_line.svg?react';
import LocationLineIconImport from './location_line.svg?react';
import LockLineIconImport from './lock_line.svg?react';
import MailLineIconImport from './mail_line.svg?react';
import MailSendLineIconImport from './mail_send_line.svg?react';
import MedalLineIconImport from './medal_line.svg?react';
import Message2LineIconImport from './message_2_line.svg?react';
import MessagesCircleIconImport from './messages-circle.svg?react';
import MinusCircleIconImport from './minus_circle_line.svg?react';
import More2LineIconImport from './more_2_line.svg?react';
import MortarboardFillIconImport from './mortarboard_fill.svg?react';
import MortarboardLineIconImport from './mortarboard_line.svg?react';
import NewFolderLineIconImport from './new_folder_line.svg?react';
import Notebook2FillIconImport from './notebook_2_fill.svg?react';
import Notebook2LineIconImport from './notebook_2_line.svg?react';
import NotificationFillIconImport from './notification_fill.svg?react';
import NotificationLineIconImport from './notification_line.svg?react';
import NotificationOffLineIconImport from './notification_off_line.svg?react';
import PdfFileIconImport from './pdf.svg?react';
import PencilLineIconImport from './pencil_line.svg?react';
import PhoneLineIconImport from './phone_line.svg?react';
import PicLineIconImport from './pic_line.svg?react';
import Pin2FillIconImport from './pin_2_fill.svg?react';
import Pin2LineIconImport from './pin_2_line.svg?react';
import PinLineIconImport from './pin_line.svg?react';
import PlayButtonIconImport from './play_button.svg?react';
import PlayLineIconImport from './play_line.svg?react';
import PollIconImport from './poll.svg?react';
import PostIconImport from './post.svg?react';
import Presentation1LineIconImport from './presentation_1_line.svg?react';
import Presentation2LineIconImport from './presentation_2_line.svg?react';
import QrCodeLineIconImport from './qrcode_line.svg?react';
import QuestionLineIconImport from './question_line.svg?react';
import RadarLineIconImport from './radar_line.svg?react';
import Refresh4LineIconImport from './refresh_4_line.svg?react';
import RepeatLineImport from './repeat_line.svg?react';
import RightLineImport from './right_line.svg?react';
import RocketLineIconImport from './rocket_line.svg?react';
import SadFaceIconImport from './sad-face.svg?react';
import Search2LineIconImport from './search_2_line.svg?react';
import Settings5LineIconImport from './settings_5_line.svg?react';
import ShareForwardLineIconImport from './share_forward_line.svg?react';
import SheetFileIconImport from './sheet.svg?react';
import ShieldShapeLineIconImport from './shield_shape_line.svg?react';
import SiteMapLineIconImport from './sitemap_line.svg?react';
import StarLineIconImport from './star_line.svg?react';
import TagLineIconImport from './tag_line.svg?react';
import TelehealthLineIconImport from './telehealth_line.svg?react';
import TimeFilledIconImport from './time_fill.svg?react';
import TimeLineIconImport from './time_line.svg?react';
import Upload2LineIconImport from './upload_2_line.svg?react';
import User1LineIconImport from './user_1_line.svg?react';
import User3LineIconImport from './user_3_line.svg?react';
import User4LineIconImport from './user_4_line.svg?react';
import UserAddLineIconImport from './user_add_line.svg?react';
import UserEditLineIconImport from './user_edit_line.svg?react';
import UserSecurityLineIconImport from './user_security_line.svg?react';
import VideoFileIconImport from './video.svg?react';
import VideoFillIconImport from './video_fill.svg?react';
import VideoLineIconImport from './video_line.svg?react';
import WithingsOrderPostIconImport from './withings_order_post.svg?react';

export const ActivityIcon = withAntIconWrapper(ActivityIconImport);
export const BellRingingLineIcon = withAntIconWrapper(BellRingingLineIconImport);
export const BellRingingFillIcon = withAntIconWrapper(BellRingingFillIconImport);
export const ShieldShapeLineIcon = withAntIconWrapper(ShieldShapeLineIconImport);
export const ForbidCircleLineIcon = withAntIconWrapper(ForbidCircleLineIconImport);
export const Pin2LineIcon = withAntIconWrapper(Pin2LineIconImport);
export const PinLineIcon = withAntIconWrapper(PinLineIconImport);
export const Pin2FillIcon = withAntIconWrapper(Pin2FillIconImport);
export const ListCheck3LineIcon = withAntIconWrapper(ListCheck3LineIconImport);
export const CellPhoneIcon = withAntIconWrapper(CellPhoneLineIconImport);
export const ChurchLineIcon = withAntIconWrapper(ChurchLineIconImport);
export const FolderLineIcon = withAntIconWrapper(FolderLineIconImport);
export const LayoutLeftFillIcon = withAntIconWrapper(LayoutLeftFillIconImport);
export const LayoutLeftLineIcon = withAntIconWrapper(LayoutLeftLineIconImport);
export const GridLineIcon = withAntIconWrapper(GridLineIconImport);
export const MedalLineIcon = withAntIconWrapper(MedalLineIconImport);
export const EventIcon = withAntIconWrapper(EventIconImport);
export const NotificationLineIcon = withAntIconWrapper(NotificationLineIconImport);
export const More2LineIcon = withAntIconWrapper(More2LineIconImport);
export const SadFaceIcon = withAntIconWrapper(SadFaceIconImport);
export const HeartbeatIcon = withAntIconWrapper(HeartbeatIconImport);
export const BellCircleIcon = withAntIconWrapper(BellCircleIconImport);
export const ListCheckIcon = withAntIconWrapper(ListCheckIconImport);
export const ListCircleIcon = withAntIconWrapper(ListCircleIconImport);
export const InviteIcon = withAntIconWrapper(InviteIconImport);
export const MessagesCircleIcon = withAntIconWrapper(MessagesCircleIconImport);
export const GameIcon = withAntIconWrapper(GameIconImport);
export const DownLineIcon = withAntIconWrapper(DownLineImport);
export const HeartLineIcon = withAntIconWrapper(HeartLineIconImport);
export const HeartFillIcon = withAntIconWrapper(HeartFillIconImport);
export const HistoryLineIcon = withAntIconWrapper(HistoryLineIconImport);
export const Chat3LineIcon = withAntIconWrapper(Chat3LineIconImport);
export const BookmarkLineIcon = withAntIconWrapper(BookmarkLineIconImport);
export const BookmarkFillIcon = withAntIconWrapper(BookmarkFillIconImport);
export const CheckLineIcon = withAntIconWrapper(CheckLineIconImport);
export const ShareForwardLineIcon = withAntIconWrapper(ShareForwardLineIconImport);
export const LinkLine = withAntIconWrapper(LinkLineImport);
export const PencilLineIcon = withAntIconWrapper(PencilLineIconImport);
export const Flag1LineIcon = withAntIconWrapper(Flag1LineIconImport);
export const Delete2LineIcon = withAntIconWrapper(Delete2LineIconImport);
export const CloseCircleLineIcon = withAntIconWrapper(CloseCircleLineIconImport);
export const RepeatLine = withAntIconWrapper(RepeatLineImport);
export const FacebookIcon = withAntIconWrapper(FacebookIconImport);
export const LinkedInIcon = withAntIconWrapper(LinkedInIconImport);
export const MailSendLineIcon = withAntIconWrapper(MailSendLineIconImport);
export const RightLine = withAntIconWrapper(RightLineImport);
export const EyeLineIcon = withAntIconWrapper(EyeLineIconImport);
export const StarLineIcon = withAntIconWrapper(StarLineIconImport);
export const AddLine = withAntIconWrapper(AddLineImport);
export const HornLineIcon = withAntIconWrapper(HornLineIconImport);
export const QuestionLineIcon = withAntIconWrapper(QuestionLineIconImport);
export const CloseLineIcon = withAntIconWrapper(CloseLineIconImport);
export const NotificationOffLineIcon = withAntIconWrapper(NotificationOffLineIconImport);
export const TimeFilledIcon = withAntIconWrapper(TimeFilledIconImport);
export const Search2LineIcon = withAntIconWrapper(Search2LineIconImport);
export const DotGridLineIcon = withAntIconWrapper(DotGridLineIconImport);
export const BillLineIcon = withAntIconWrapper(BillLineIconImport);
export const CheckCircleFillIcon = withAntIconWrapper(CheckCircleFillIconImport);
export const CloseCircleFillIcon = withAntIconWrapper(CloseCircleFillIconImport);
export const TagLineIcon = withAntIconWrapper(TagLineIconImport);
export const TimeLineIcon = withAntIconWrapper(TimeLineIconImport);
export const RadarLineIcon = withAntIconWrapper(RadarLineIconImport);
export const ArrowLeftLineIcon = withAntIconWrapper(ArrowLeftLineIconImport);
export const PicLineIcon = withAntIconWrapper(PicLineIconImport);
export const LightLineIcon = withAntIconWrapper(LightLineIconImport);
export const CheckFillIcon = withAntIconWrapper(CheckFillIconImport);
export const CheckGreenIcon = withAntIconWrapper(CheckGreenIconImport);
export const DropboxIcon = withAntIconWrapper(DropboxIconImport);
export const ComputerLineIcon = withAntIconWrapper(ComputerLineIconImport);
export const BankLineIcon = withAntIconWrapper(BankLineIconImport);
export const BankFillIcon = withAntIconWrapper(BankFillIconImport);
export const Home4LineIcon = withAntIconWrapper(Home4LineIconImport);
export const Home4FillIcon = withAntIconWrapper(Home4FillIconImport);
export const VideoLineIcon = withAntIconWrapper(VideoLineIconImport);
export const VideoFillIcon = withAntIconWrapper(VideoFillIconImport);
export const MortarboardLineIcon = withAntIconWrapper(MortarboardLineIconImport);
export const MortarboardFillIcon = withAntIconWrapper(MortarboardFillIconImport);
export const CalendarLineIcon = withAntIconWrapper(CalendarLineIconImport);
export const CalendarFillIcon = withAntIconWrapper(CalendarFillIconImport);
export const HandHeartLineIcon = withAntIconWrapper(HandHeartLineIconImport);
export const HandHeartFillIcon = withAntIconWrapper(HandHeartFillIconImport);
export const CommentLineIcon = withAntIconWrapper(CommentLineIconImport);
export const Notebook2LineIcon = withAntIconWrapper(Notebook2LineIconImport);
export const Notebook2FillIcon = withAntIconWrapper(Notebook2FillIconImport);
export const CompassLineIcon = withAntIconWrapper(CompassLineIconImport);
export const CompassFillIcon = withAntIconWrapper(CompassFillIconImport);
export const Classify2LineIcon = withAntIconWrapper(Classify2LineIconImport);
export const Classify2FillIcon = withAntIconWrapper(Classify2FillIconImport);
export const DocumentLineIcon = withAntIconWrapper(DocumentLineIconImport);
export const EarthLineIcon = withAntIconWrapper(EarthLineIconImport);
export const EnterLineIcon = withAntIconWrapper(EnterLineIconImport);
export const LockLineIcon = withAntIconWrapper(LockLineIconImport);
export const MailLineIcon = withAntIconWrapper(MailLineIconImport);
export const GroupLineIcon = withAntIconWrapper(GroupLineIconImport);
export const CalendarMonthIcon = withAntIconWrapper(CalendarMonthIconImport);
export const PlayButtonIcon = withAntIconWrapper(PlayButtonIconImport);
export const SiteMapLineIcon = withAntIconWrapper(SiteMapLineIconImport);
export const PlayLineIcon = withAntIconWrapper(PlayLineIconImport);
export const PollIcon = withAntIconWrapper(PollIconImport);
export const PostIcon = withAntIconWrapper(PostIconImport);
export const FileCheckLineIcon = withAntIconWrapper(FileCheckLineIconImport);
export const ArchiveLineIcon = withAntIconWrapper(ArchiveLineIconImport);
export const CalendarTimeAddFillIcon = withAntIconWrapper(CalendarTimeAddFillIconImport);
export const Eye2LineIcon = withAntIconWrapper(Eye2LineIconImport);
export const CopyLineIcon = withAntIconWrapper(CopyLineIconImport);
export const LocationLineIcon = withAntIconWrapper(LocationLineIconImport);
export const User1LineIcon = withAntIconWrapper(User1LineIconImport);
export const User4LineIcon = withAntIconWrapper(User4LineIconImport);
export const ExchangeDollarLineIcon = withAntIconWrapper(ExchangeDollarLineIconImport);
export const PhoneLineIcon = withAntIconWrapper(PhoneLineIconImport);
export const QrCodeLineIcon = withAntIconWrapper(QrCodeLineIconImport);
export const Message2LineIcon = withAntIconWrapper(Message2LineIconImport);
export const MinusCircleIcon = withAntIconWrapper(MinusCircleIconImport);
export const CheckCircleLineIcon = withAntIconWrapper(CheckCircleLineIconImport);
export const UserEditLineIcon = withAntIconWrapper(UserEditLineIconImport);
export const Chat1LineIcon = withAntIconWrapper(Chat1LineIconImport);
export const Comment2LineIcon = withAntIconWrapper(Comment2LineIconImport);
export const BriefcaseLineIcon = withAntIconWrapper(BriefcaseLineIconImport);
export const ListCheckLineIcon = withAntIconWrapper(ListCheckLineIconImport);
export const AddCircleLineIcon = withAntIconWrapper(AddCircleLineIconImport);
export const NewFolderLineIcon = withAntIconWrapper(NewFolderLineIconImport);
export const Upload2LineIcon = withAntIconWrapper(Upload2LineIconImport);
export const ArrowRightLineIcon = withAntIconWrapper(ArrowRightLineIconImport);
export const User3LineIcon = withAntIconWrapper(User3LineIconImport);
export const UserSecurityLineIcon = withAntIconWrapper(UserSecurityLineIconImport);
export const HeartBeatLineIcon = withAntIconWrapper(HeartBeatLineIconImport);
export const Settings5LineIcon = withAntIconWrapper(Settings5LineIconImport);
export const InformationLineIcon = withAntIconWrapper(InformationLineIconImport);
export const ExitLineIcon = withAntIconWrapper(ExitLineIconImport);
export const RocketLineIcon = withAntIconWrapper(RocketLineIconImport);
export const UserAddLineIcon = withAntIconWrapper(UserAddLineIconImport);
export const ArrowDownLineIcon = withAntIconWrapper(ArrowDownLineIconImport);
export const DownSmallLineIcon = withAntIconWrapper(DownSmallLineIconImport);
export const Document3LineIcon = withAntIconWrapper(Document3LineIconImport);
export const InboxLineCircleIcon = withAntIconWrapper(InboxLineCircleIconImport);
export const Presentation2LineIcon = withAntIconWrapper(Presentation2LineIconImport);
export const Presentation1LineIcon = withAntIconWrapper(Presentation1LineIconImport);
export const TelehealthLineIcon = withAntIconWrapper(TelehealthLineIconImport);
export const Document3FillIcon = withAntIconWrapper(Document3FillIconImport);
export const HospitalLineIcon = withAntIconWrapper(HospitalLineIconImport);
export const FolderIcon = withAntIconWrapper(FolderIconImport);
export const VideoFileIcon = withAntIconWrapper(VideoFileIconImport);
export const SheetFileIcon = withAntIconWrapper(SheetFileIconImport);
export const PdfFileIcon = withAntIconWrapper(PdfFileIconImport);
export const DocumentFileIcon = withAntIconWrapper(DocumentFileIconImport);
export const ImgFileIcon = withAntIconWrapper(ImgFileIconImport);
export const DefaultFileIcon = withAntIconWrapper(FileDefaultIconImport);
export const EyeCloseIcon = withAntIconWrapper(EyeCloseIconImport);
export const Refresh4LineIcon = withAntIconWrapper(Refresh4LineIconImport);
export const BubbleLineIcon = withAntIconWrapper(BubbleLineIconImport);
export const Key2LineIcon = withAntIconWrapper(Key2LineIconImport);
export const Chat1FillIcon = withAntIconWrapper(Chat1FillIconImport);
export const NotificationFillIcon = withAntIconWrapper(NotificationFillIconImport);
export const WithingsOrderPostIcon = withAntIconWrapper(WithingsOrderPostIconImport);
